// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__xTGdb","subheader":"ReorderModal_subheader__1Tlik","listWrap":"ReorderModal_listWrap__2ina4"};